/**
 * @file Project detail adapter contract.
 */

import {
    getProjectDetailFields,
    setupProjectDetailPeopleControls,
    setupProjectDetailScalarControls,
    setupProjectDetailTypeControls,
} from './projectDetails.js';

/**
 * Detail adapter for Project parent items.
 */
export const projectDetailAdapter = {
    itemType: 'project',
    viewName: 'projects',
    statusConfigKey: 'projectStatus',
    typeConfigKey: 'projectTypes',
    liveSaveFields: [
        'priority',
        'project_manager',
        'status',
        'types',
    ],
    sections: [
        'linkedTasks',
        'checklist',
        'notes',
        'attachments',
    ],
    renderFields: getProjectDetailFields,
    mountControls(detailsViewContainer, item) {
        setupProjectDetailScalarControls(detailsViewContainer, item);
        setupProjectDetailTypeControls(detailsViewContainer, item);
        setupProjectDetailPeopleControls(detailsViewContainer, item);
    },
    getBackNavigation() {
        return { type: 'view', view: 'projects' };
    },
    getDeleteNavigation() {
        return { type: 'view', view: 'projects' };
    },
};
